
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.24996 11.6465L8.04286 6.85363C8.35784 6.53864 8.89641 6.76173 8.89641 7.20718V11.0001H14.8964C18.2101 11.0001 20.8964 13.6864 20.8964 17.0001H18.8964C18.8964 14.7909 17.1055 13.0001 14.8964 13.0001H8.89641V16.793C8.89641 17.2384 8.35784 17.4615 8.04286 17.1465L3.24996 12.3536C3.0547 12.1584 3.0547 11.8418 3.24996 11.6465Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowreturnFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
